const $ = window.jQuery;

$(() => {
    const $filters = $('.posts__filters .filter');

    if (!$filters.length) {
        return;
    }

    $($filters).on('click', e => {
        const $TARGET = e.currentTarget;

        // Hide all dropdowns
        $('.filter__filter').removeClass('-visible');

        // Show correct clicked one
        $($TARGET)
            .find('.filter__filter')
            .toggleClass('-visible');
    });
});
